"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDiffInDays = exports.getTimeDiff = exports.formatTime = exports.dateToNanos = exports.isPastDate = exports.dateFromNanos = exports.ONE_MILLION = void 0;
const format_1 = __importDefault(require("date-fns/format"));
exports.ONE_MILLION = 1000000n;
const dateFromNanos = (timestamp) => {
    return new Date(Number(BigInt(timestamp) / exports.ONE_MILLION));
};
exports.dateFromNanos = dateFromNanos;
const isPastDate = (timestamp) => {
    return Number(BigInt(timestamp) / exports.ONE_MILLION) < Date.now();
};
exports.isPastDate = isPastDate;
const dateToNanos = (date) => {
    const millis = (date || new Date()).getTime();
    return BigInt(millis) * exports.ONE_MILLION;
};
exports.dateToNanos = dateToNanos;
const formatTime = (timestamp) => {
    return (0, format_1.default)((0, exports.dateFromNanos)(timestamp), 'PPp');
};
exports.formatTime = formatTime;
const getTimeDiff = (start, end) => {
    let diff = end.getTime() - start.getTime();
    let diffInHrs = Math.abs(diff) / (1000 * 3600);
    let timeSuffix = 'ago';
    if (diff < 0n) {
        timeSuffix = 'ago';
    }
    if (diffInHrs < 1) {
        return `${Math.floor(Math.abs(diff) / (1000 * 60))} minutes ` + timeSuffix;
    }
    else if (diffInHrs < 24) {
        return `${Math.floor(diffInHrs)} hours ` + timeSuffix;
    }
    else {
        if (diffInHrs >= 24 * 30) {
            return `${Math.floor(diffInHrs / 24 / 30) + Math.ceil((Math.floor(diffInHrs / 24) % 30) / 30)} month(s) ` + timeSuffix;
        }
        else {
            return `${Math.floor(diffInHrs / 24)} days ` + timeSuffix;
        }
    }
};
exports.getTimeDiff = getTimeDiff;
const getDiffInDays = (expirationDate, end_date = new Date()) => {
    let curDate = end_date;
    let expDate = new Date((0, exports.formatTime)(expirationDate));
    let diff = curDate.getTime() - expDate.getTime();
    let diffInHrs = Math.abs(diff) / (1000 * 3600);
    let endStr = "";
    if (diffInHrs < 24) {
        endStr = `${Math.floor(diffInHrs)}hrs`;
    }
    else {
        if (diffInHrs >= 24 * 30) {
            endStr = `${Math.floor(diffInHrs / 24 / 30) + Math.ceil((Math.floor(diffInHrs / 24) % 30) / 30)} month(s)`;
        }
        else {
            endStr = `${Math.floor(diffInHrs / 24)} days`;
        }
    }
    if (diff > 0) {
        return `${endStr} ago`;
    }
    return `Ends in ${endStr}`;
};
exports.getDiffInDays = getDiffInDays;
